import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "href", "onClick", "showAsButton", "target", "params", "push", "updateParams"];
import { connect } from 'react-redux';
import { push as _push } from 'FormsUI/actions/HistoryActions';
import { updateParams as _updateParams } from '../../actions/ReactRouter';
import { isAppRoute } from 'FormsUI/lib/RouteGenerators';
import BaseAppLink from 'ui-forms-components/links/AppLink';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const AppLink = _ref => {
  let {
      children = /*#__PURE__*/_jsx(_Fragment, {
        children: " "
      }),
      href = '',
      onClick = __ => {},
      showAsButton = false,
      target = '',
      params = {},
      push = () => {},
      updateParams = () => {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseAppLink, Object.assign({
    href: href,
    onClick: onClick,
    showAsButton: showAsButton,
    target: target,
    params: params,
    onPush: push,
    onUpdateParams: updateParams,
    isAppRoute: isAppRoute
  }, props, {
    children: children
  }));
};
const mapDispatchToProps = {
  push: _push,
  updateParams: _updateParams
};
export default connect(null, mapDispatchToProps)(AppLink);